import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Rocket,
  Cpu,
  Shield,
  ScanText,
  MessagesSquare,
  ScrollText,
  Settings,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

interface NavSection {
  title?: string;
  items: NavItem[];
}

const sections: NavSection[] = [
  {
    items: [{ to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    title: 'Gateway',
    items: [
      { to: '/deployments', label: 'Deployments', icon: Rocket },
      { to: '/models', label: 'Models', icon: Cpu },
      { to: '/swap-profiles', label: 'Swap Profiles', icon: Shield },
      { to: '/custom-recognizers', label: 'Custom szűrők', icon: ScanText },
    ],
  },
  {
    title: 'Observability',
    items: [
      { to: '/conversations', label: 'Conversations', icon: MessagesSquare },
      { to: '/audit-log', label: 'Audit Log', icon: ScrollText },
    ],
  },
  {
    title: 'System',
    items: [{ to: '/settings', label: 'Settings', icon: Settings }],
  },
];

export function Sidebar(): JSX.Element {
  return (
    <aside className="flex h-screen w-60 flex-col border-r border-border bg-sidebar">
      <div className="flex h-14 items-center gap-2 border-b border-border px-4">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-echo-gold text-sm font-bold text-echo-ink">
          E
        </span>
        <span className="text-lg font-medium text-heading">
          Echo<span className="text-echo-gold">Proxy</span>
        </span>
      </div>
      <nav className="flex-1 space-y-0.5 overflow-y-auto p-2">
        {sections.map((section, i) => (
          <div key={section.title ?? `section-${i}`}>
            {section.title && (
              <p className="px-3 pb-1 pt-4 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                {section.title}
              </p>
            )}
            {section.items.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-2 rounded-md border-l-2 px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'border-echo-gold bg-echo-gold/10 text-heading'
                      : 'border-transparent text-muted-foreground hover:bg-muted hover:text-foreground',
                  )
                }
              >
                <Icon className={cn('h-4 w-4')} />
                <span>{label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div className="border-t border-border p-3 text-[10px] text-muted-foreground">
        v0.1.0 · {new Date().getFullYear()}
      </div>
    </aside>
  );
}
